import { Link } from "react-router-dom";

export const Logo = ({ dark = false, testid = "site-logo" }) => (
  <Link to="/" data-testid={testid} className="flex items-center group shrink-0" aria-label="Hope Centers home">
    <img
      src={dark ? "/logo-light.png" : "/logo.png"}
      alt="Hope Centers International"
      className="h-9 md:h-10 w-auto transition-transform duration-500 group-hover:scale-[1.03]"
    />
  </Link>
);
